export enum ScrapeUiStatus {
    READY = 'Ready',
    RUNNING = 'Running',
    PAUSED = 'Paused',
}
